import { useEffect, useState } from 'react';
import API from '../../api/axios';
import AppLayout from '../../components/layout/AppLayout';
import { Page, PageHeader } from '../../components/ui';
import CommandesEnLigne from '../../components/commandes/CommandesEnLigne';

// Administration des commandes en ligne : configuration des canaux WhatsApp / Messenger
// de chaque établissement (réservée à l'admin), et suivi des commandes et conversations.
export default function CommandesAdmin() {
  const [etablissements, setEtablissements] = useState([]);

  useEffect(() => {
    API.get('/etablissements')
      .then(r => setEtablissements(r.data.etablissements || r.data || []))
      .catch(() => {});
  }, []);

  return (
    <AppLayout role="admin">
      <Page>
        <PageHeader
          title="Commandes en ligne"
          subtitle="Connexion WhatsApp et Messenger des établissements, réglages de l'agent, commandes et conversations"
        />
        <CommandesEnLigne etablissements={etablissements} admin />
      </Page>
    </AppLayout>
  );
}
